export default "__VITE_ASSET__BKHe0kdY__"